//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            active: 'general',
            tabs: [
                {
                    name: 'general',
                    component: 'game-help-tab-general',
                    label: this.$lang.get('helpers.game.general'),
                    icon: {
                        name: 'info',
                        x: 380
                    },
                    robi: 'robi_questionmark',
                    robiBubbleText: this.$lang.get('helpers.game.sometimes', {br: '\n'})
                },
                {
                    name: 'questions',
                    component: 'game-help-tab-questions',
                    label: this.$lang.get('helpers.game.help'),
                    icon: {
                        name: 'question',
                        x: 580
                    },
                    robi: 'robi_reading',
                    robiBubbleText: this.$lang.get('helpers.game.planets', {br: '\n'})
                },
                {
                    name: 'contact',
                    component: 'game-help-tab-contact',
                    label: this.$lang.get('helpers.game.contact'),
                    icon: {
                        name: 'contact',
                        x: 720
                    },
                    robi: 'robi_postman',
                    robiBubbleText: this.$lang.get('helpers.game.write')
                }
            ]
        };
    },

    computed: {
        activeTab () {
            return this.tabs.find(tab => tab.name === this.active);
        }
    },

    created () {
        this.storeVisit();

        if (this.$route.params && this.$route.params.gameroute) {
            this.active = 'questions';
        }
    },

    methods: {
        storeVisit () {
            axios.post('game/help', {
                url: this.$store.getters.prevRoute
            }).then(() => {}).catch(() => {});
        }
    }
};
